
export function numeral(count: number, one: string, two: string, five: string){
	if(!count) count = 0;
	//десять-девятнадцать
	if(count%100/10>>0 === 1)
		return five;
	//ноль, пять-девять
	if(count%10 >= 5 || count%10===0)
		return five;
	//один
	if(count%10 === 1)
		return one;

	//две-четыре
	return two;
}

export function num(count: number | undefined | null | false, one: string, two: string, five: string){
  if (typeof count !== "number") return ""
	return count + " " + numeral(count, one, two, five)
}

export const capitalize = (str: string) => {
	return str.charAt(0).toUpperCase() + str.slice(1)
}